import { Component } from '@angular/core';
import { AnalyticsService } from '@frk/eds-components';
import { Document } from '@models';
import { ICellRendererParams } from '@ag-grid-community/core';
import { extractFileInfoFromLink } from '@utils/link-utils';
import { N_A } from '@products/utils/constants/product.constants';
import { hasValue } from '@products/utils/mappers/mapper.utils';

@Component({
  selector: 'ft-fund-document-cell-renderer',
  templateUrl: './fund-document-cell-renderer.component.html',
  styleUrls: ['./fund-document-cell-renderer.component.scss'],
})
export class FundDocumentCellRendererComponent {
  document: Document;
  /**
   * Params
   */
  private params: ICellRendererParams;

  /**
   * Custom parameters to be used in edsButton directive
   */
  eventParams = {};

  public fundName = '';

  /**
   * Constructor
   */
  constructor(private analytics: AnalyticsService) {}

  /**
   * On ag init
   */
  agInit(params: ICellRendererParams) {
    this.params = params;
    const documents: Document[] = this.params.data.documents;
    this.document = documents?.find((document) => document.showOnPpss);
    this.fundName = this.params.data.fundName;
    // for showing the unique fund name in aria-label
    if (hasValue(this.params.data.shareClass.identifiers, 'ticker')) {
      this.fundName += ' - ' + this.params.data.shareClass.identifiers.ticker;
    } else if (this.params.data.shareClass.shareClassName !== N_A) {
      this.fundName += ' - ' + this.params.data.shareClass.shareClassName;
    }
    this.fundName += ' - PDF';
  }

  triggerAnalyticsEvent(): void {
    const targetUrl = this.document.link;
    const {
      fileName,
      fileExtension,
    }: { fileName: string; fileExtension: string } = extractFileInfoFromLink(
      targetUrl
    );
    this.analytics.trackEvent({
      event: 'file_download',
      detailed_event: 'Download Link Clicked',
      link_text: this.params?.data?.fundName,
      link_url: targetUrl,
      file_name: fileName,
      file_extension: fileExtension,
      location: '',
      event_data: {
        file_extension: fileExtension,
        file_lit_code: '',
        file_name: fileName,
        link_text: this.params?.data?.fundName,
        link_url: targetUrl,
        location: '',
      },
    });
  }
}
